import {
  CloseButton as ChakraCloseButton,
  CloseButtonProps as ChakraCloseButtonProps,
} from "@chakra-ui/react";
import type { CloseButtonSharedProps } from "./CloseButton.props";

export default function CloseButton({
  isDisabled,
  disabled,
  size,
  ...props
}: CloseButtonProps): JSX.Element {
  // Map v1/v2 props to v3 props for backward compatibility
  const disabledValue = disabled !== undefined ? disabled : isDisabled;

  return <ChakraCloseButton disabled={disabledValue} size={size} {...props} />;
}

export type CloseButtonProps = CloseButtonSharedProps & ChakraCloseButtonProps;
